export const subscriptionTypes = {
  SET_MANAGE_SUBSCRIPTION_MODAL_VISIBILITY:
    "SET_MANAGE_SUBSCRIPTION_MODAL_VISIBILITY",
  SET_PLAN_UPGRADE_NEEDED_MODAL_CONTEXT:
    "SET_PLAN_UPGRADE_NEEDED_MODAL_CONTEXT",
  SET_SUBSCRIPTION_MODAL_MODE: "SET_SUBSCRIPTION_MODAL_MODE",
  SET_SUBSCRIPTION_CONTACT_MODAL_DISPLAY_MODE:
    "SET_SUBSCRIPTION_CONTACT_MODAL_DISPLAY_MODE",
  SET_UNLOCK_ADDONS_MODAL_VISIBILITY: "SET_UNLOCK_ADDONS_MODAL_VISIBILITY",
  SET_ADD_BILLING_INFO_MODAL_VISIBILITY:
    "SET_ADD_BILLING_INFO_MODAL_VISIBILITY",
  GET_SUBSCRIPTION_BILLING_INFO: "GET_SUBSCRIPTION_BILLING_INFO",
  GET_SUBSCRIPTION_BILLING_INFO_SUCCESS:
    "GET_SUBSCRIPTION_BILLING_INFO_SUCCESS",
  GET_SUBSCRIPTION_PLAN: "GET_SUBSCRIPTION_PLAN",
  GET_SUBSCRIPTION_PLAN_SUCCESS: "GET_SUBSCRIPTION_PLAN_SUCCESS",
  GET_SUBSCRIPTION_ENTITLEMENT: "GET_SUBSCRIPTION_ENTITLEMENT",
  GET_SUBSCRIPTION_ENTITLEMENT_SUCCESS: "GET_SUBSCRIPTION_ENTITLEMENT_SUCCESS",
};
